export default __webpack_public_path__ + "static/overview1-ff54e9294ac07f10d51eb2e80cbcd221.jpg";